<template>
  <div></div>
</template>

<script>
export default {
  name: 'ErpTaskCenterPage',
};
</script>
